import React from "react";

const AboutUsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.1 15.5H11.9V10.1H10.1V15.5ZM11 8.3C11.255 8.3 11.4688 8.21375 11.6413 8.04125C11.8138 7.86875 11.9 7.655 11.9 7.4C11.9 7.145 11.8138 6.93125 11.6413 6.75875C11.4688 6.58625 11.255 6.5 11 6.5C10.745 6.5 10.5313 6.58625 10.3588 6.75875C10.1863 6.93125 10.1 7.145 10.1 7.4C10.1 7.655 10.1863 7.86875 10.3588 8.04125C10.5313 8.21375 10.745 8.3 11 8.3ZM11 20C9.755 20 8.585 19.7638 7.49 19.2913C6.395 18.8188 5.4425 18.1775 4.6325 17.3675C3.8225 16.5575 3.18125 15.605 2.70875 14.51C2.23625 13.415 2 12.245 2 11C2 9.755 2.23625 8.585 2.70875 7.49C3.18125 6.395 3.8225 5.4425 4.6325 4.6325C5.4425 3.8225 6.395 3.18125 7.49 2.70875C8.585 2.23625 9.755 2 11 2C12.245 2 13.415 2.23625 14.51 2.70875C15.605 3.18125 16.5575 3.8225 17.3675 4.6325C18.1775 5.4425 18.8188 6.395 19.2913 7.49C19.7638 8.585 20 9.755 20 11C20 12.245 19.7638 13.415 19.2913 14.51C18.8188 15.605 18.1775 16.5575 17.3675 17.3675C16.5575 18.1775 15.605 18.8188 14.51 19.2913C13.415 19.7638 12.245 20 11 20ZM11 18.2C13.01 18.2 14.7125 17.5025 16.1075 16.1075C17.5025 14.7125 18.2 13.01 18.2 11C18.2 8.99 17.5025 7.2875 16.1075 5.8925C14.7125 4.4975 13.01 3.8 11 3.8C8.99 3.8 7.2875 4.4975 5.8925 5.8925C4.4975 7.2875 3.8 8.99 3.8 11C3.8 13.01 4.4975 14.7125 5.8925 16.1075C7.2875 17.5025 8.99 18.2 11 18.2Z"
        fill={props.themeName != "light"?"#DADADA":"#333333"}
      />
    </svg>
  );
};

export default AboutUsIcon;
